import { WorldObjectType, } from "../api";
import { Vector3 } from "three";
import { BaseObject } from "./objects";
import { CompositeCamera } from "../private/objects/composite_camera";
export class CameraObject extends BaseObject {
    constructor(fov, aspect, near, far) {
        const camera = new CompositeCamera(fov, aspect, near, far);
        super(camera);
        this.object = camera;
    }
    setProjectionMode(view) {
        this.object.setProjectionMode(view);
    }
    getProjectionMode() {
        return this.object.getProjectionMode();
    }
    getPerspective() {
        return this.object.perspective;
    }
    getOrthographic() {
        return this.object.orthographic;
    }
    setAspectRatio(ratio) {
        this.object.perspective.setAspectRatio(ratio);
        this.object.orthographic.setAspectRatio(ratio);
    }
    getAspectRatio() {
        return this.object.perspective.aspect;
    }
    getFarPlane() {
        return this.object.getCurrentCamera().far;
    }
    getNearPlane() {
        return this.object.getCurrentCamera().near;
    }
    getForwardVector(target) {
        const scratch = new Vector3();
        this.object.getWorldDirection(scratch);
        if (typeof target !== "undefined") {
            target.x = scratch.x;
            target.y = scratch.y;
            target.z = scratch.z;
            return target;
        }
        else {
            return {
                x: scratch.x,
                y: scratch.y,
                z: scratch.z,
            };
        }
    }
    getProjectionMatrix(proj) {
        const camera = this.object.getCurrentCamera();
        return camera.getProjectionMatrix(proj);
    }
    getInverseProjectionMatrix(proj) {
        const camera = this.object.getCurrentCamera();
        return camera.getInverseProjectionMatrix(proj);
    }
    getWorldMatrix(mat) {
        if (typeof mat !== "undefined") {
            mat.elements.length = 16;
            for (let i = 0; i < mat.elements.length; i += 1) {
                mat.elements[i] = this.object.matrixWorld.elements[i];
            }
            return mat;
        }
        else {
            return this.object.matrixWorld.clone();
        }
    }
    getLocalMatrix(mat) {
        if (typeof mat !== "undefined") {
            mat.elements.length = 16;
            for (let i = 0; i < mat.elements.length; i += 1) {
                mat.elements[i] = this.object.matrix.elements[i];
            }
            return mat;
        }
        else {
            return this.object.matrix.clone();
        }
    }
    getObjectType() {
        return WorldObjectType.CameraObject;
    }
    asCameraObject() {
        return this;
    }
}
